import * as React from "react";
import PropTypes from "prop-types";
import LoginStore from "../LoginStore";
import FullPageSpinner from "./FullPageSpinner";
import {withRouter} from "react-router-dom";

class LoginWithSSOToken extends React.Component {
  static propTypes = {
    history: PropTypes.any,
    persistent: PropTypes.bool,
    ssoToken: PropTypes.string.isRequired
  }

  state = {
    didErr: false
  }

  componentDidMount() {
    this.tryLogin()
  }

  tryLogin = () => {
    this.setState({ didErr: false });
    const {ssoToken, persistent, history} = this.props
    return LoginStore.tryLoginSSO(ssoToken, {
      persistent
    })
      .then(() => {
        history.push("/");
      })
      .catch(ex => {
        console.error(ex)
        this.setState({didErr: true})
      })
  }

  render() {
    if (this.state.didErr) {
      return <div className="h-100 d-flex flex-column"><div className="alert alert-danger m-auto">Authentication Failed <a
        className="link" onClick={this.tryLogin}>Try Again?</a></div></div>
    } else {
      return <FullPageSpinner />
    }
  }
}

export default withRouter(LoginWithSSOToken)
